import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import permissionsService from "@/services/permissionsService";
import { fetchRecurringEmails } from "@/modules/emailManagement/features/RecurringEmailManagement/api/fetchRecurringEmails/fetchRecurringEmailsApi";
import { RecurringEmail } from "@/modules/emailManagement/features/RecurringEmailManagement/api/fetchRecurringEmails/types";

export function useRecurringEmailList() {
  const navigate = useNavigate();
  const { hasPermission } = permissionsService();
  const canAddSubscribers =
    hasPermission("administration-email-management") &&
    hasPermission("administration-users");

  const [recurringEmails, setRecurringEmails] = useState<RecurringEmail[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadRecurringEmails = async () => {
      try {
        const response = await fetchRecurringEmails();
        setRecurringEmails(response.data);
      } catch {
        // Error handled by axios interceptor
      } finally {
        setIsLoading(false);
      }
    };

    loadRecurringEmails();
  }, []);

  const decrementSubscriberCount = useCallback((recurringEmail: string) => {
    setRecurringEmails((prev) =>
      prev.map((item) =>
        item.recurringEmail === recurringEmail
          ? { ...item, subscriberCount: Math.max(0, item.subscriberCount - 1) }
          : item,
      ),
    );
  }, []);

  const goToAddSubscriber = useCallback(() => {
    navigate("/admin/email/recurring/subscribe");
  }, [navigate]);

  return {
    recurringEmails,
    isLoading,
    decrementSubscriberCount,
    canAddSubscribers,
    goToAddSubscriber,
  };
}
